import { analyticsUtils } from 'utils/analytics-utils';

/**
 * Событие срабатывает, когда нажимаешь по кнопкам комнат
 */

export const gaClickRoom = ({
  elementBlock,
  elementName,
  elementText,
  elementVariant,
}: {
  elementBlock: string;
  elementName: string;
  elementText: string;
  elementVariant: string;
}) =>
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock,
    elementName,
    elementText,
    elementVariant,
  });
